import { GraphicElement, GraphicElementEntity } from "./graphQL";

export const getGraphicElementsFromGQResult = (entities?: GraphicElementEntity[]): GraphicElement[] => {
    return (entities ?? []).map(({ paragraph, providers, react, kpiReportTemplate, ...rest }) => {
        return {
            ...rest,
            providers:
                providers === null ? null : providers === undefined ? undefined : providers?.filter(d => d != null),
            paragraph: paragraph,
            react: react,
            kpiReportTemplate: kpiReportTemplate
        };
    });
};
